import { React, useCallback, useEffect, useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import { EffectCoverflow, Navigation } from "swiper";
import { SVGIcons, ImgIcons, Imgbanner } from "../../Helpers/Common";
import { Link } from "react-router-dom";
import { Showdetailspopup } from "../Showdetailspopup/Showdetailspopup";
var SVGIcon = "";
SVGIcons().then((resultData) => (SVGIcon = resultData));
var ImageData = "";
ImgIcons().then((result) => (ImageData = result));


export function Layout5(props) {
  const [showdetails, setshowdetails] = useState(false);
  const [details, setdetails] = useState(false);
  // const [showShimmer, setShowShimmer] = useState(true);

  // const handleTimeout = useCallback(() => {
  //   setShowShimmer(false);
  // }, []);

  // useEffect(() => {
  //   // const timer = setTimeout(() => {
  //     setShowShimmer(false);
  //   // }, 1000);

  //   // return () => {
  //   //   clearTimeout(timer);
  //   // };
  // }, [handleTimeout]);

  function showdetailspop(data) {
    setshowdetails(true);
    setdetails(data);
  }

  let Closepopup = () => {
    setshowdetails(false);
  };

  return (
    <>
      {window.innerWidth > 768 ?
        <>
          <section className="mb-0 dD-block">
            <div className="temp29">
              {/* {showShimmer ? (
                <div className="linedesk" />
              ) : ( */}
              <>
                <div className="head-layout">
                  <h3>
                    {props.title.display_title}
                    <span className="red">{props.title.display_title_sufix}</span>
                  </h3>
                </div>
              </>
              {/* )} */}

              <div className="temp29-area">
                <Swiper
                  navigation={{
                    prevEl: ".slick-prev",
                    nextEl: ".slick-next",
                  }}
                  initialSlide={4}
                  slidesPerView={4.5}
                  effect={"coverflow"}
                  grabCursor={true}
                  centeredSlides={true}
                  coverflowEffect={{
                    rotate: 20,
                    stretch: 23,
                    depth: 100,
                    modifier: 1,
                    slideShadows: true,
                  }}
                  pagination={true}
                  breakpoints={{
                    650: {
                      slidesPerView: 1,
                    },
                    850: {
                      slidesPerView: 6.3,
                    },
                  }}
                  modules={[EffectCoverflow, Navigation]}
                  className="temp29-slider"
                >
                  <div className="side-overlay-L dD-block"></div>
                  <button
                    className="slick-prev slick-arrow"
                    type="button"
                    aria-label="Previous"
                  />
                  {props.Layout1.map((data, index) => {
                    var GenereTitle = data.genres.split(",");
                    GenereTitle = GenereTitle[0];
                    return (
                      <SwiperSlide key={index}>
                        {/* {showShimmer ? (
                          <img src={ImageData["placeholder2.png"]} alt="shimmer" className="shimmer" />
                        ) : ( */}
                        <>
                          <Link to={"/" + data.slug}>
                            <img src={data.vertical_banner.small} />
                          </Link>
                        </>
                        {/* )} */}
                      </SwiperSlide>
                    );
                  })}
                  <div className="side-overlay-R dD-block"></div>
                  <button
                    className="slick-next slick-arrow"
                    type="button"
                    aria-label="Next"
                  />
                </Swiper>
              </div>
            </div>
          </section>
        </>
        :
        <>
          <section className="mb-0 dD-none">
            <div className="temp29">
              {/* {showShimmer ? (
                <div className="line linehead" />
              ) : ( */}
              <>
                <div className="head">
                  <h3>
                    {props.title.display_title}
                    <span className="red">{props.title.display_title_sufix}</span>
                  </h3>
                </div>
              </>
              {/* )} */}
              <div className="temp29-area">
                <Swiper
                  slidesPerView={1.5}
                  effect={"coverflow"}
                  grabCursor={true}
                  centeredSlides={false}
                  coverflowEffect={{
                    rotate: 0,
                    stretch: 30,
                    depth: 100,
                    modifier: 3,
                    slideShadows: true,
                  }}
                  breakpoints={{
                    700: {
                      slidesPerView: 4.2,
                      effect: false,
                      spaceBetween: 16,
                    },
                    810: {
                      slidesPerView: 4.2,
                      effect: false,
                      spaceBetween: 16,
                    },
                  }}
                  pagination={true}
                  modules={[EffectCoverflow]}
                  className="temp29-slider"
                >
                  {props.Layout1.map((data, index) => {
                    var GenereTitle = data.genres.split(",");
                    var keyword = data.keywords.split(",")[0];
                    GenereTitle = GenereTitle[0];
                    return (
                      <SwiperSlide key={index}>
                        {/* {showShimmer ? (
                          <img src={ImageData["placeholder2.png"]} alt="shimmer" className="shimmer" />
                        ) : ( */}
                        <>
                          <img
                            src={data.vertical_banner.small}
                            onClick={() => {
                              showdetailspop(data);
                            }}
                          />
                          {/* <div className="bay-title">{keyword}</div> */}
                        </>
                        {/* )} */}
                      </SwiperSlide>
                    );
                  })}
                </Swiper>
              </div>
            </div>
          </section>
        </>
      }


      {showdetails ? (
        <Showdetailspopup data={details} Closebtn={Closepopup} silverIcon={props.silverIcon}
          goldenIcon={props.goldenIcon} />
      ) : null}
    </>
  );
}

export default Layout5;
